import { Component, DestroyRef, inject } from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LocaleService } from '../../../../translation/services/locale.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InputWrapperComponent } from '../../../../shared/components/input/input-wrapper/input-wrapper.component';
import { IconComponent } from '../../../../shared/icons/icon.component';
import {
  ThemeMode,
  ThemePreferenceService,
} from '../../../../core/services/theme-preference.service';

@Component({
  selector: 'app-page-settings',
  imports: [
    ReactiveFormsModule,
    CardComponent,
    TranslatePipe,
    InputWrapperComponent,
  ],
  templateUrl: './page-settings.component.html',
  styleUrl: './page-settings.component.scss',
})
export class PageSettingsComponent {
  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);
  private readonly localeService = inject(LocaleService);
  private readonly themePreferenceService = inject(ThemePreferenceService);

  readonly supportedLanguages = this.localeService.supportedLanguages;
  readonly themeModes: ThemeMode[] = ['light', 'dark', 'system'];
  readonly form: FormGroup = this.fb.group({
    selectedLanguage: [this.localeService.userLanguage],
    themeMode: [this.themePreferenceService.themeMode],
  });

  constructor() {
    this.form.controls['selectedLanguage'].valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language) => {
        if (typeof language === 'string') {
          this.localeService.setLanguage(language);
        }
      });

    this.form.controls['themeMode'].valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((themeMode) => {
        if (
          themeMode === 'light' ||
          themeMode === 'dark' ||
          themeMode === 'system'
        ) {
          this.themePreferenceService.setTheme(themeMode);
        }
      });
  }
}
